import axios from "axios";

import { CertificateModel, parseCertificateModel } from "@teamprevent/common/healthSurveillance/certificate/models";

const buildUrl = (customerId: string, ohCaseId: string, taskId: string) =>
    `/api/${customerId}/ohCase/${ohCaseId}/task/${taskId}/healthSurveillanceCertificate`;

const getHealthSurveillanceCertificate = async (customerId: string, ohCaseId: string, taskId: string) => {
    const response = await axios.get<CertificateModel>(buildUrl(customerId, ohCaseId, taskId));
    return parseCertificateModel(response.data);
};

export const healthSurveillanceCertificateApi =  { getHealthSurveillanceCertificate };
